/* global MEDIA_ROOT */

import React, { PropTypes } from 'react';

import { container, imageContainer, image, smallContainer, smallImageContainer } from './styles.module.css';

const EventLogo = ({
  className,
  logo,
  small,
}) => (
  <div className={[small ? smallContainer : container, className].join(' ')}>
    <div className={small ? smallImageContainer : imageContainer}>
      <img src={logo} alt="" className={image} />
    </div>
  </div>
);

EventLogo.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * String URL for logo image.
   */
  logo: PropTypes.string,
  small: PropTypes.bool,
};

EventLogo.defaultProps = {
  className: '',
  logo: `${MEDIA_ROOT}/images/placeholder-200x200.png`,
  small: false,
};

export default EventLogo;



// WEBPACK FOOTER //
// ./app/src/components/EventLogo/index.jsx